import classNames from 'classnames'
import { useCallback, useState } from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { getUrlParam, getUrlWithParams } from 'core-components/helpers/url'
import { Button } from 'core-components/library/button'
import { Grid, Item } from 'core-components/library/grid'
import { NotificationController } from 'core-components/library/popup'
import { EmptySitePage } from 'core-components/sitebuilder/layout/flexGridWrapper/EmptySitePage'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { LoginButton } from 'src/core/components/shared/header/headerWithMenu/LoginButton'
import { useUserStore } from 'src/core/hooks/services/useUserStore'

import { Logo } from './components/Logo'
import { SurveyContent } from './components/SurveyContent'

import styles from './Survey.module.scss'

export const Survey = () => {
  const email = useSelector(selectUser).email
  const isr: string = getUrlParam('isr')

  const isGuest = useUserStore().isGuestUser() || !email
  const [link, setLink] = useState<string>('')
  const [isDone, setIsDone] = useState<boolean>(false)

  const generateLink = useCallback(() => {
    const page = getUrlWithParams({ isr: email })
    setLink(document.location.origin + page)
  }, [email])

  const copy = () => {
    navigator.clipboard.writeText(link).then(() => {
      NotificationController.showSuccess({ message: 'Copied!' })
    })
  }

  const onFinished = useCallback(() => {
    setIsDone(true)
  }, [])

  useEffect(() => {
    if (!isGuest && !isr) {
      generateLink()
    }
  }, [isGuest, isr, generateLink])

  if (isGuest && !isr) {
    return <EmptySitePage footerContent={() => <LoginButton />} />
  }

  return (
    <div className={styles.root}>
      <Grid className={styles.grid} bottomMargin={'none'}>
        <Item xs={12} md={6} className={styles.grid__item}>
          <div className={classNames(styles.left, isDone ? '' : styles['left--align-left'])}>
            <div className={styles.left__header}>
              <div className={styles.header__text}>SURVEY</div>
              <div className={styles.header__logo}>
                <Logo />
              </div>
            </div>
            <div className={styles.left__desc}>You’re opinion counts!</div>
          </div>
        </Item>
        <Item xs={12} md={6} className={styles.grid__item}>
          {!isr && !isGuest ? (
            <div className={styles.isr}>
              <div className={styles.isr__header}>Your personal link to the survey:</div>
              <div className={styles.isr__link}>{link}</div>
              <Button
                icon={'kbase kbase-copy'}
                margin={'sm'}
                onClick={copy}
                className={styles.isr__button}
              >
                Copy personal link
              </Button>
            </div>
          ) : (
            <SurveyContent isr={isr} isDone={isDone} onFinished={onFinished} />
          )}
        </Item>
      </Grid>
    </div>
  )
}

export default Survey
